import { ComponentType, createContext, useContext } from 'react';
import { Backfill, OnArrowClick, GapSize, Orientation } from '../types';

type InternalScrollCarouselContextType = {
    carouselOrientation: Orientation;
    itemsToShow: number;
    stepSize: number;
    showArrows: boolean;
    currentIndex: number;
    totalItems: number;
    isInfinite: boolean;
    backfill: Backfill;
    isEndSnapScroll: boolean;
    setCurrentIndex: (index: number) => void;
    isScrollable: boolean;
    isBackfillInit: boolean;
    onArrowClick?: OnArrowClick;
    showDots: boolean;
    DotComponent?: ComponentType;
    gapSize: GapSize;
};

const InternalScrollCarouselContext = createContext<InternalScrollCarouselContextType | null>(null);

export const useInternalScrollCarousel = (): InternalScrollCarouselContextType => {
    const context = useContext(InternalScrollCarouselContext);
    if (!context) {
        throw new Error(
            'useInternalScrollCarousel must be used within a InternalScrollCarouselProvider'
        );
    }
    return context;
};

export const InternalScrollCarouselProvider = InternalScrollCarouselContext.Provider;
